export enum OAuthChallengeMethod {
  S256 = 'S256'
}